import { PlatformLocation } from '@angular/common';
import { Component, Injector, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { StringUtils } from '@pk/powerkioskutils';
import { Subject } from 'rxjs';

import { environment } from 'src/environments/environment';
import { ServiceLocator } from './core/auth/services';
import { AppStateService } from './core/auth/services/app-state.service';
import { DataLayerService } from './core/auth/services/data-layer.service';
import { FooterComponent } from './core/dashboard/components/footer/footer.component';
import { NavbarComponent } from './core/dashboard/components/navbar/navbar.component';

@Component({
    selector: 'pkd-root',
    imports: [RouterOutlet, NavbarComponent, FooterComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnDestroy {
	public appReady: boolean;
	private destroy$ = new Subject<void>();

	constructor(
		injector: Injector,
		platformLocation: PlatformLocation,
		protected appStateService: AppStateService,
		private router: Router,
		private dataLayerService: DataLayerService,
	) {
		ServiceLocator.injector = injector;
		this.appStateService.onReady.subscribe((ready: { app: boolean }) => {
			this.appReady = ready.app;
		});

		function getRequester(origin: string): string {
			return StringUtils.removeLastCharacter(origin, '/').replace('www.', '').split('/').splice(0, 3).join('/').toLowerCase();
		}

		const origin = platformLocation.href;
		environment.apiKey = (environment.apiKeys as any)[getRequester(origin)];
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
